import { Slide } from '../../common/models';
export class Category {
  _id: string;
  name: string = '';
  slug: string = '';
  image: string = '';
  metaTitle: string = '';
  metaDescription: string = '';
  active: boolean = false;
  discontinued: boolean = false;
  showFilters: boolean = false;
  slides: Array<Slide> = [];
  created: Date;
  updated: Date;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/shared/category.model.ts